const ActionType = {
  RESET: "INPUT_FEEDBACK_RESET",
  RAISE_ERRORS: "INPUT_FEEDBACK_RAISE_ERRORS",
};

export default ActionType;
